// moms-harness:anchor v2
// Spec: docs/spec/auth/SPEC-auth-okta-account-switch-redirect-A.yaml

import { useCallback, useState } from 'react'
import { PrimaryButton } from '@musinsa/layer-components-desktop'
import AuthStatusPage from '@/pages/auth/components/AuthStatusPage'
import MAlert from '@/utils/modal/MAlert'
import { prepareOktaAccountSwitchRedirect } from '@/utils/okta/oktaAuth'

type AuthAccessDeniedState = 'IDLE' | 'SIGNING_OUT' | 'SIGN_OUT_FAILED'

function OktaAccessDenied() {
  const [status, setStatus] = useState<AuthAccessDeniedState>('IDLE')
  const isLoggingOut = status === 'SIGNING_OUT'

  const handleSwitchAccount = useCallback(async () => {
    if (isLoggingOut) return

    setStatus('SIGNING_OUT')

    let redirectUrl: string
    try {
      redirectUrl = await prepareOktaAccountSwitchRedirect()
    } catch {
      setStatus('SIGN_OUT_FAILED')
      MAlert.show('Okta 로그아웃에 실패했습니다. 잠시 후 다시 시도해주세요.')
      return
    }

    globalThis.location.assign(redirectUrl)
  }, [isLoggingOut])

  return (
    <AuthStatusPage
      iconName="ic-lock"
      title="MOMS에 접근할 수 없는 계정이에요"
      description={'현재 Okta 계정에는 MOMS 사용 권한이 없어요\nMOMS 권한이 있는 계정으로 다시 로그인하거나 관리자에게 문의하세요'}
    >
      <PrimaryButton variant="filled" size="xlarge" disabled={isLoggingOut} onClick={handleSwitchAccount}>
        다른 계정으로 로그인
      </PrimaryButton>
    </AuthStatusPage>
  )
}

export default OktaAccessDenied
